module.exports = __webpack_public_path__ + "static/media/info.6ae75902.svg";